import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export function CategoryTile({ to, title, description, badge, image, index = 0, testId }) {
  return (
    <Link
      to={to}
      data-testid={testId}
      className="group relative flex min-h-[18rem] flex-col justify-end overflow-hidden rounded-2xl border border-white/8 bg-vault-card p-6 transition-all duration-300 hover:border-cyan-glow/40 hover:shadow-[0_16px_50px_rgba(6,182,212,0.18)] animate-fade-up"
      style={{ animationDelay: `${index * 90}ms` }}
    >
      <div className="absolute inset-0">
        <img
          src={image}
          alt={title}
          loading="lazy"
          className="h-full w-full object-cover opacity-35 transition-all duration-500 group-hover:scale-105 group-hover:opacity-50"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-vault-black via-vault-black/80 to-vault-black/30" />
      </div>
      <div className="relative z-10">
        {badge && (
          <span className="overline mb-3 inline-block rounded-full border border-cyan-glow/30 bg-vault-black/60 px-3 py-1 backdrop-blur">
            {badge}
          </span>
        )}
        <h3 className="font-display text-2xl font-bold text-white">{title}</h3>
        <p className="mt-2 max-w-sm text-sm text-slate-300">{description}</p>
        <span className="mt-4 inline-flex items-center gap-1 text-sm font-semibold text-cyan-300 transition-colors group-hover:text-cyan-bright">
          Preskúmať
          <ArrowUpRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
        </span>
      </div>
    </Link>
  );
}

export default CategoryTile;
